import { makeStyles } from '@material-ui/core/styles';

const Color = '#242424';
const LineHeight = '17px';
const Root = {
  color: Color,
  fontFamily: "Proxima Nova",
  fontSize: "14px",
  letterSpacing: 0,
  lineHeight: LineHeight
};
export const SelectStyles = {
  formControl: {
    flexGrow: 1,
    height: 30,
    border: '1px solid var(--light-grey)',

    "& > div": {
      height: 30,
      borderRadius: 0
    },

    "& fieldset": {
      display: "none"
    },

    "& div": {
      ...Root,
      backgroundColor: "white"
    },

    "& div:focus": {
      backgroundColor: "white !important",
    }
  },

  paper: {
    minWidth: 300,
    maxWidth: 350
  },

  list: {
    "& li": {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "inline-block",
      width: "100%"
    }
  },

  outlined: {
    padding: 0,
    paddingLeft: 10
  },

  selected: {
    backgroundColor: "var(--primary) !important",
    color: "var(--white) !important"
  },

  root: Root,
};

const useStyles = makeStyles(() => SelectStyles);

export default useStyles;
